export default __webpack_public_path__ + "static/media/edit.888ce7cf.svg";